import { PageHero } from "@/components/common/PageHero";
import { IndustriesGrid, ContactBand } from "@/components/home/Sections";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES } from "@/data/site";

export default function Industries() {
  useSeo({
    title: "Industries | Manufacturing Sectors Served by AutoMex, Pune",
    description: "AutoMex serves automotive, auto components, engineering, EV & battery, defence & aerospace, metal fabrication, warehousing, electronics and process industries.",
    path: "/industries",
  });
  return (
    <>
      <PageHero
        overline="Industries"
        title="Engineered for Every Manufacturing Sector."
        subtitle="AutoMex supports a broad range of industrial and manufacturing sectors with infrastructure and technology solutions."
        image={IMAGES.productionLine}
        crumb="Industries"
      />
      <IndustriesGrid withHeading={false} />
      <ContactBand />
    </>
  );
}
